import api from "@/api/axios";

export default {
  namespaced: true,
  state: () => ({
    items: [],
    allItems: [],
    pagination: {
      currentPage: 0,
      totalPages: 0,
      totalElements: 0
    }
  }),
  getters: {
    getItems: (state) => state.items,
    getAllItems: (state) => state.allItems,
    getPagination: (state) => state.pagination,
  },
  mutations: {
    setItems(state, items) {
      state.items = items
    },
    setAllItems(state, items) {
      state.allItems = items
    },
    setPagination(state, paginationData) {
      state.pagination = paginationData;
    }
  },
  actions: {
    async fetchAll({ commit, dispatch }) {
      try {
        dispatch('ui/startLoading', null, { root: true });
        const response = await api.get('/supplier/all');
        const supplierNormalized = normalizedSupplier(response.data);
        commit('setAllItems', supplierNormalized);
      } catch (error) {
        dispatch('ui/notify',  { 
          message: 'Não possível carregar a lista de fornecedores', 
          color: 'error' 
        }, { root: true } );

        commit('setAllItems', []);
        console.error('Erro ao carregar fornecedores: ', error);
      } finally {
        dispatch('ui/stopLoading', null, { root: true });
      }
    },
    async fetchAllOnPagination({ commit, dispatch }, params = {}) {
      try {
        dispatch('ui/startLoading', null, { root: true });

        const requestParams = {
          page: params.page || 0,
          size: params.size || 10,
          search: params.search || null,
        };

        if (params.startDate && params.endDate) {
          requestParams.startDate = params.startDate;
          requestParams.endDate = params.endDate;
        }

        const response = await api.get('/supplier/pagination', { params: requestParams });

        const supplierNormalized = normalizedSupplier(response.data.content);
        commit('setItems', supplierNormalized);
        commit('setPagination', {
          currentPage: response.data.number,
          totalPages: response.data.totalPages,
          totalElements: response.data.totalElements
        });
      } catch (error) {
        const msgError = 'Erro ao carregar o histórico de vendas';

        dispatch('ui/notify',  { 
          message: msgError, 
          color: 'error' 
        }, { root: true } );

        commit('setItems', []);
        commit('setPagination', { currentPage: 0, totalPages: 0, totalElements: 0 });
        
        console.error('Erro ao carregar o histórico de vendas', error);
      } finally {
        dispatch('ui/stopLoading', null, { root: true });
      }
    },
    async delete({ commit, dispatch }, id) {
      try {
        dispatch('ui/startLoading', null, { root: true });

        await api.delete(`supplier/delete/${id}`);
        await dispatch('fetchAll');
        await dispatch('fetchAllOnPagination');

        dispatch('ui/notify', {
          message: 'Fornecedor excluído com sucesso!',
          color: 'success'
        }, { root: true });

        return true;
      } catch (error) {
        dispatch('ui/notify',  { 
          message: 'Não foi possível excluir este fornecedor.', 
          color: 'error'
        }, { root: true } );
        console.error('Erro ao excluir o fornecedor: ', error);

        return false;
      } finally {
        dispatch('ui/stopLoading', null, { root: true });
      }
    },
    async save({ commit, dispatch }, newItem) {
      try {
        dispatch('ui/startLoading', null, { root: true });

        const response = await api.post('/supplier/save', newItem);
        await dispatch('fetchAll');
        await dispatch('fetchAllOnPagination');

        dispatch('ui/notify', {
          message: 'Fornecedor registrado com sucesso!',
          color: 'success'
        }, { root: true });

        return true;
      } catch (error) {
        console.error('Erro ao salvar um novo fornecedor: ', error);
        dispatch('ui/notify', {
          message: 'Erro ao tentar registrar este Fornecedor',
          color: 'error'
        },{ root: true });

        return false;
      } finally {
        dispatch('ui/stopLoading', null, { root: true });
      }
    },
    async update({ commit, dispatch }, editedItem) {
      try {
        dispatch('ui/startLoading', null, { root: true });

        const response = await api.put(`/supplier/update/${editedItem.id}`, editedItem);
        
        await dispatch('fetchAll');
        await dispatch('fetchAllOnPagination');

        dispatch('ui/notify', {
          message: 'Fornecedor atualizado com sucesso!',
          color: 'success'
        }, { root: true });

        return true;
      } catch (error) {
        console.error('Erro ao editar o fornecedor: ', error);
        
        dispatch('ui/notify', {
          message: 'Erro ao tentar atualizar este Fornecedor.',
          color: 'error'
        }, { root: true });

        return false;
      } finally {
        dispatch('ui/stopLoading', null, { root: true });
      }
    }
  }
}


/**
 * Normaliza os dados brutos vindos do Back-end.
 * Converte Enums para labels amigáveis e adiciona metadados.
 * @param {Array} data - Array de objetos vindos da API.
 * @returns {Array} Array de objetos normalizados.
 */
function normalizedSupplier(data) {
  if (!data || !Array.isArray(data)) return [];

  return data.map(item => ({
    ...item,
    entity: 'suppliers'
  }));
}